module.exports = __webpack_public_path__ + "static/media/garage-large.51bf3b21.png";